import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Tags } from './types'
import { RootState } from '../types'

export const state: Tags = {
  tags: [],
  filterTags: [],
  personGroups: [],
  filterPersonGroups: [],
  currentTag: {},
  currentThingsTagged: [],
  currentAgentsTagged: [],
  currentPersonsTagged: [],
  responseMessage: '',
  responseError: false
}

const namespaced = true

export const tags: Module<Tags, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
